import { ActivityFilterDefault } from '@shared/models/filter.model';

export const defaultRatingFilters: ActivityFilterDefault<string>[] = [{ value: '5' }, { value: '4' }, { value: '3' }];

export const defaultDurationFilters: ActivityFilterDefault<DurationFilterValue>[] = [
  { value: '0-1', name: 'TravelActivitiesSideFilter:Duration1' },
  { value: '1-4', name: 'TravelActivitiesSideFilter:Duration2' },
  { value: '4-24', name: 'TravelActivitiesSideFilter:Duration3' },
  { value: '24-', name: 'TravelActivitiesSideFilter:Duration4' },
];

export const defaultTimeFilters: ActivityFilterDefault<string>[] = [
  { value: '6am-12pm', name: 'TravelActivitiesSideFilter:TimeOfDay1' },
  { value: '12pm-5pm', name: 'TravelActivitiesSideFilter:TimeOfDay2' },
  { value: '5pm-12am', name: 'TravelActivitiesSideFilter:TimeOfDay3' },
];

export type DurationFilterValue = '0-1' | '1-4' | '4-24' | '24-';
